import React from 'react'

function AlarmasSucursal(props) {
    const { alarmas,guardarAccion } = props;
    function accionAlarma(item, estado) {
        var infoSuc = {"ID_SUCURSAL":item.ID_SUCURSAL,"ID_ALARMA":item.ID_ALARMA,"IP_ALARMA":item.IP_ALARMA}
        var action ='';
        var activo =0;
        if(estado){
            action = item.COD_ON
            activo=1;
        }else{
            action = item.COD_OF
            activo = 0;
        }
        guardarAccion({
            ...infoSuc,"ACTION":action,"ACTIVO":activo
        });
    }
    return (
        <div>
            {alarmas.map((item, index) => {
                if(item.IP_ALARMA!==null&&item.IP_ALARMA!==''){
                return (
                    <div className={`${item.ACTIVO==1?'bg-success':'bg-danger'}  bg-gradient text-center pb-4`} key={index}>
                        <div className='fw-bold'>{item.DESCRIPCION}</div>
                        <div className='btn-group w-100'>
                            <button className='btn-success btn-sm w-100 mx-1' onClick={()=>accionAlarma(item,true)}>ON</button>
                            <button className='btn-danger btn-sm w-100 mx-1' onClick={()=>accionAlarma(item,false)}>OFF</button>
                        </div>
                    </div>
                )
                }
            })}
        </div>
    )
}

export default AlarmasSucursal